export const Languages = Object.freeze({
  All: 'ui_countryAll',
});
